import React, { type ReactNode } from "react"
import { SnapBg } from "../snapBg"
import ImageWhiteFire from "../../assets/images/white_fire_only_left.png"
import ImageWhiteFireRight from "../../assets/images/white_fire_only_right.png"
import { type ChakraProps } from "@chakra-ui/react"
import { safeMaxWidth } from "../../common/commonConstants"

interface SnapFireBgWrapperProps {
  children: ReactNode
  SnapFireBgWrapperProps?: ChakraProps
  pos?: "left" | "right"
}

const SnapFireBgWrapper: React.FC<SnapFireBgWrapperProps> = ({ children, SnapFireBgWrapperProps, pos }) => {
  return (
    <div>
      <SnapBg
        chakraProps={{
          pos: "fixed",
          w: safeMaxWidth,
          top: "0",
          left: "0",
          bg: "primary",
          bgRepeat: "no-repeat",
          bgSize: "contain",
          backgroundPosition: pos === "left" ? "-50px 100%" : "100% 145%",
          backgroundImage: pos === "left" ? ["", "", "", "", `url(${ImageWhiteFire})`] : ["", "", "", "", `url(${ImageWhiteFireRight})`],
          ...(SnapFireBgWrapperProps && { ...SnapFireBgWrapperProps })
        }}
        position="left"
      >
        {children}
      </SnapBg>
    </div>
  )
}

export default SnapFireBgWrapper
